module.exports = __webpack_public_path__ + "img/configurazione invio mail.c216c8db.png";